module.exports = __webpack_public_path__ + "img/littl_girls.a17a6130.jpg";